import { Component, OnInit, Input} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAssessment, ISection, IQuestion} from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-question-notes',
  templateUrl: './question-notes.component.html',
})
export class QuestionNotesComponent implements OnInit {

  @Input() question: IQuestion = {
    section: 0,
    id: 0,
    xref: '00000000-0000-0000-0000-000000000000',
    title: '',
    description: '',
    risk_id: 0,
    risk_trigger: 0,
    reward_id: 0,
    reward_trigger: 0,
    progress: 0,
    notes: '',
  };

  questionNotesForm = this.fb.group({
    notes: [''],
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: RoughcheckService,
    private message: MessageService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    // TODO Check that the Roughcheck is loaded and this is the question
    if (! this.service.getARef()) {
      this.router.navigate(['/start']);
      return;
    }

    this.question = this.service.getQuestion();
    this.questionNotesForm.controls.notes.setValue(this.question.notes);
  }

  /**
   * Save notes and return to questions
   */
  onSubmit() {
    const data = this.questionNotesForm.controls.notes.value;
    this.question.notes = data;
    this.service.setHttpQuestion(this.question)
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Return to questions without saving
   */
  onCancel() {
    this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'sections']);
  }

  /**
   * Populate Roughcheck and user assessment
   */
  private handleSuccess(resp: HttpResponse<any>) {
    // Ignoring the response as the assessment page will re-load
    this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'sections']);
  }

}
